export const PAYMENT_FAILED_PHONE_NUMBER = '0345 600 7256';
export const PAYMENT_FAILED_TEL_HREF = 'tel:03456007256';

export const CUSTOMER_CARE_PHONE_NUMBER = '0800 188 884';
export const CUSTOMER_CARE_TEL_HREF = 'tel:0800188884';
